import { type } from "@testing-library/user-event/dist/type";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useJWT from "../../hooks/useJWT";
import useCart from "../../hooks/useCart";
import useCheckout from "../../hooks/useCheckout";
import useShipment from "../../hooks/useShipment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Accordion from 'react-bootstrap/Accordion';
import ModalGlobal from "../global/ModalGlobal";
import useBank from "../../hooks/useBank";
import useAddress from "../../hooks/useAddress";
import { useAppConfig } from '../../context/AppConfigContext';
import { formatCurrencyLocal, formatNumberLocal } from "../../utils/stringManipulator";

// const paymentMethods = [
//   {
//     id: 0,
//     name: "Trasfer",
//     type: 0,
//     img: "transfer.png",
//   },
//   {
//     id: 1,
//     name: "Paynow",
//     type: 1,
//     img: "paynow.png",
//   },
// ];

const paymentMethods = [
  {
    id: 0,
    name: "Trasfer",
    type: 0,
    img: "transfer.png",
  },
  {
    id: 1,
    name: "Paynow",
    type: 1,
    img: "paynow.png",
  },
];

const Checkout = ({ addressEnumChange, selectedAddress, onSelectAddress }) => {
  const { config } = useAppConfig();
  const { user } = useJWT();
  const navigate = useNavigate();

  const [selectedShipmentData, setSelectedShipmentData] = useState(null);
  const [selectedShipmentDetailData, setSelectedShipmentDetailData] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState(0);
  const [selectedPayment, setSelectedPayment] = useState(1);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [show, setShow] = useState(false);

  const [orderSubtotal, setOrderSubtotal] = useState(0);
  const [orderShipping, setOrderShipping] = useState(0);
  const [orderTotal, setOrderTotal] = useState(0);

  const getItemPrice = (item) => {
    if (item?.productPrice) {
      return (item.productPrice.discountPrice !== null && item.productPrice.discountPrice !== undefined && item.productPrice.discountPrice > 0)
        ? item.productPrice.discountPrice
        : item.productPrice.price;
    }
    return item?.price || 0;
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { fetchCart, data, status } = useCart();
  const { fetchActiveShipment, data: activeShipment, status: shipmentStatus, fetchSingleShipment, single } = useShipment();
  const { fetchActiveBank, data: activeBank } = useBank();

  const {
    fetchAddress,
    data: address,
    status: addressStatus,
  } = useAddress();

  const {
    checkout,
    data: dataProceedCheckout,
    redirect,
    status: checkoutStatus,
    error: checkoutError,
    resetStatus,
  } = useCheckout();

  useEffect(() => {
    if (user && user.id) {
      fetchAddress(user.id);
      fetchCart(user.id);
      fetchActiveShipment();
      fetchActiveBank();
    }
  }, [user]);

  useEffect(() => {
    if (shipmentStatus !== "loading") {
      if (shipmentStatus === "done") {
        setSelectedShipmentData(activeShipment[0]);
        setSelectedShipmentDetailData(activeShipment[0].details[0]);
        setOrderShipping(activeShipment[0].details[0]?.price);
      }
    }
  }, [shipmentStatus, activeShipment]);

  useEffect(() => {
    if (data) {
      const prodTotal = data
        .reduce(
          (total, item) => total + (getItemPrice(item) * item?.qty || 0),
          0
        );
      setOrderSubtotal(prodTotal);
      setOrderTotal(prodTotal + orderShipping);
    }
  }, [data, orderShipping]);

  useEffect(() => {
    if (addressStatus === "done") {
      if (address && address.length > 0) {
        const isPrimaryAddress = address.find((address) => address.isPrimary);
        if (isPrimaryAddress) {
          onSelectAddress(isPrimaryAddress);
        }
      }
    }
  }, [addressStatus, address]);

  useEffect(() => {
    if (checkoutStatus === "done") {
      // if (selectedPayment === 0) {
      //   window.location.href = redirect;
      // } else {
      //   // For Paynow or other payment methods, redirect to success page
      //   navigate("/payment/complete");
      // }
      localStorage.setItem('checkoutData', JSON.stringify(dataProceedCheckout));
      navigate("/payment/complete");
    } else if (checkoutStatus === "error") {
      Swal.fire({
        title: "Error",
        text: checkoutError || "Something went wrong during checkout",
        icon: "error",
      });
      resetStatus();
    }
  }, [checkoutStatus, redirect]);

  const handlePaymentChange = (event) => {
    console.log(event.target.id);
    setSelectedBankId(event.target.id);
  };

  const handleSelectAddress = () => {
    addressEnumChange(1);
  };

  const onCheckout = () => {
    const isChecked = document.querySelector('input[name="payment"]:checked') !== null;

    if (selectedAddress === null) {
      Swal.fire(
        "Error!",
        "Select an address before proceeding to checkout.",
        "error"
      );
      return;
    }

    if (selectedShipmentData === null && selectedShipmentDetailData === null) {
      Swal.fire(
        "Error!",
        "Select delivery option before proceeding to checkout.",
        "error"
      );
      return;
    }

    if (!isChecked) {
      Swal.fire(
        "Error!",
        "Select a payment method before proceeding to checkout.",
        "error"
      );
      return;
    }

    if (data && data.length > 0) {
      const payment = {
        userId: user.id,
        cartIds: data.map((item) => item.id).join(","),
        voucherCode: "",
        paymentMethod: selectedPaymentType,
        paymentGateway: 3, //Bank (Manualy Change)
        bankTransferId: selectedBankId,
        addressId: selectedAddress?.id || null,
        expeditionSettingId: selectedShipmentData?.id,
        expeditionSettingDetailId: selectedShipmentDetailData?.id
      };

      checkout(payment);
    } else {
      Swal.fire("Error!", "Your cart is empty.", "error");
      return;
    }
  };

  return (
    <>
      <section className="checkout py-80">
        <div className="container container-md">
          <button
            onClick={handleSelectAddress}
            className="border border-gray-100 rounded-8 px-30 py-20 mb-40 w-100"
          >
            <div className="d-block d-lg-flex align-items-center justify-content-between">
              <div className="">
                <div className="d-flex align-items-center gap-16">
                  <span>
                    <i className="ph ph-map-pin text-main-one-600 mb-8" />
                  </span>
                  <h6 className="text-xl mb-8">
                    {selectedAddress?.name ?? "No Address Selected"}
                  </h6>
                  <span className="text-sm text-gray-600 mb-8">
                    {selectedAddress?.phoneNumber}
                  </span>
                </div>
                <div className="d-block d-lg-flex align-items-center justify-content-start gap-16">
                  <span className="text-start">
                    {selectedAddress?.province
                      ? `${selectedAddress?.province}, `
                      : ""}
                    {selectedAddress?.streetName
                      ? `${selectedAddress?.streetName}, `
                      : ""}
                    {selectedAddress?.otherDetail
                      ? `${selectedAddress?.otherDetail}`
                      : ""}
                  </span>
                </div>
              </div>
              <div className="d-flex align-items-center text-main-one-600">
                <span className="text-decoration-underline me-5">
                  Change Address
                </span>
                <i className="ph ph-caret-right" />
              </div>
            </div>
          </button>
          <h6 className="text-xl mb-24">Summary Orders</h6>
          <div className="cart-table border border-gray-100 rounded-8 px-24 py-40 mt-24">
            {data &&
              data.map((item, key) => (
                <div
                  className="d-flex align-items-center justify-content-between mt-16"
                  key={key}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-16">
                    <img
                      src={item.productPhotoData[0]?.url || "assets/images/thumbs/product-details-thumb1.png"}
                      alt=""
                      className="img-fluid"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "contain",
                        padding: "5px",
                        border: "1px solid #f1f1f1",
                        borderRadius: "8px",
                      }}
                    />
                    <div style={{ textWrapStyle: "balance" }}>
                      <h6 className="text-gray-900 fw-bold text-md font-heading-one mb-8">{item.productName}</h6>
                      <div>
                        <span className="text-neutral-600 fw-normal text-sm d-block mb-8">{item.variantCombinationName}</span>
                        {item?.productPrice?.uom && (
                          <span className="text-neutral-600 text-sm d-block mt-1">
                            {item.productPrice.uom} / Qty {item.productPrice.conversionQty}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="text-end" style={{ minWidth: "150px" }}>
                    <h6 className="text-xl fw-bold mb-8">x {formatNumberLocal(item.qty)}</h6>
                    <div className="d-flex justify-content-end align-items-center gap-16">
                      {item?.productPrice && item.productPrice.discountPrice !== null && item.productPrice.discountPrice !== undefined && item.productPrice.discountPrice > 0 && (
                        <h6 className="text-sm text-gray-400 text-decoration-line-through mb-8">
                          {formatCurrencyLocal(item.productPrice.price, config?.currency)}
                        </h6>
                      )}
                      <span className="text-sm fw-bold text-black mb-8">
                        {formatCurrencyLocal(getItemPrice(item), config?.currency)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            <div className="d-flex align-items-center justify-content-between mt-16 mb-8">
              <span className="text-gray-900 fw-bold text-lg font-heading-one mt-30">
                Delivery Options
              </span>
              <span className="text-gray-900 fw-normal text-sm font-heading-one mt-30">
                <a
                  href="#"
                  className="text-main-one-600 text-decoration-underline"
                  onClick={handleShow}
                >
                  View All <i className="ph ph-caret-right" />
                </a>
              </span>
            </div>
            {
              selectedShipmentData === null ? (
                <div className="border border-main-one-600 rounded-8 px-20 py-20">
                  <div className="d-flex align-items-center ">
                    <i className="ph ph-package text-main-one-600 me-10" /><h6 className="text-xl mb-0">No Delivery Selected</h6>
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-between border border-main-one-600 rounded-8 ">
                  <div className="px-20 py-20">
                    <h6 className="text-xl mb-8">{selectedShipmentData?.name}</h6>
                    <span className="text-sm text-gray-600">
                      {selectedShipmentDetailData?.name}
                    </span>
                  </div>
                  <div className="px-20 py-10 d-flex align-items-center justify-content-end gap-10">
                    <span className="text-main-900 fw-semibold text-md font-heading-one">
                      {formatCurrencyLocal(
                        selectedShipmentDetailData?.price,
                        config?.currency,
                      )}
                    </span>
                    {/* <span className="text-main-900 fw-semibold text-md font-heading-one text-decoration-line-through">
                            {selectedShipmentDetailData?.price}
                          </span> */}
                    {/* <i class="ph ph-ticket text-main-900"></i> */}
                  </div>
                </div>
              )
            }
            <div className="d-flex align-items-center justify-content-between">
              <span className="text-gray-900 fw-bold text-lg font-heading-one mt-30 w-144">
                Total {data?.length} Products
              </span>
              <span className="text-gray-900 fw-bold text-lg font-heading-one mt-30">
                {formatCurrencyLocal(orderSubtotal, config?.currency)}
              </span>
            </div>
          </div>
          <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
            <div className="">
              <div className="mb-32">
                <h6 className="text-xl mb-24">Payment Details</h6>
              </div>
              <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Order Subtotal
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {formatCurrencyLocal(orderSubtotal, config?.currency)}
                </span>
              </div>
              <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Delivery Fee
                </span>
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  {formatCurrencyLocal(orderShipping, config?.currency)}
                </span>
              </div>
              {/* <div className="mb-0 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-md fw-normal">
                  Delivery Discount
                </span>
                <span className="text-main-one-500 font-heading-one text-md fw-normal">
                  $0.00
                </span>
              </div> */}
              <div className="mt-22 pt-22 border-top border-gray-100 flex-between gap-8">
                <span className="text-gray-900 font-heading-one text-lg fw-bold">
                  Total Payment
                </span>
                <span className="text-gray-900 font-heading-one text-lg fw-bold">
                  {formatCurrencyLocal(orderTotal, config?.currency)}
                </span>
              </div>
            </div>
          </div>
          <h6 className="text-xl mb-24 mt-40">Payment Method</h6>
          <div className="d-flex gap-16">
            <button
              onClick={() => setSelectedPaymentType(0)}
              className={`border ${selectedPaymentType === 0
                ? "border-main-one-600 text-main-one-600"
                : "border-gray-100"
                } rounded-8 px-20 py-10 hover-border-main-one-600 hover-bg-main-one-50`}
            >
              Bank
            </button>
            <button
              disabled
              onClick={() => setSelectedPaymentType(1)}
              className={`border ${selectedPaymentType === 1
                ? "border-main-one-600 text-main-one-600"
                : "border-gray-100"
                } rounded-8 px-20 py-10 hover-border-main-one-600 hover-bg-main-one-50`}
            >
              Credit Card (Coming Soon)
            </button>
            <button
              disabled
              onClick={() => setSelectedPaymentType(2)}
              className={`border ${selectedPaymentType === 2
                ? "border-main-one-600 text-main-one-600"
                : "border-gray-100"
                } rounded-8 px-20 py-10 hover-border-main-one-600 hover-bg-main-one-50`}
            >
              Paynow (Coming Soon)
            </button>
          </div>
          {/* <div className={`mt-32 d-none`}>
            <div className="payment-item">
              <div className="form-check common-check common-radio py-16 mb-0">
                <input
                  className="form-check-input"
                  type="radio"
                  name="payment"
                  id="payment1"
                  checked={selectedPayment === "payment1"}
                  onChange={handlePaymentChange}
                />
                <label
                  className="form-check-label fw-semibold text-neutral-600"
                  htmlFor="payment1"
                >
                  Direct Bank transfer
                </label>
              </div>
              {selectedPayment === "payment1" && (
                <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                  <p className="text-gray-800">
                    Make your payment directly into our bank account. Please use
                    your Order ID as the payment reference. Your order will not be
                    shipped until the funds have cleared in our account.
                  </p>
                </div>
              )}
            </div>
            <div className="payment-item">
              <div className="form-check common-check common-radio py-16 mb-0">
                <input
                  className="form-check-input"
                  type="radio"
                  name="payment"
                  id="payment2"
                  checked={selectedPayment === "payment2"}
                  onChange={handlePaymentChange}
                />
                <label
                  className="form-check-label fw-semibold text-neutral-600"
                  htmlFor="payment2"
                >
                  Check payments
                </label>
              </div>
              {selectedPayment === "payment2" && (
                <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                  <p className="text-gray-800">
                    Make your payment directly into our bank account. Please use
                    your Order ID as the payment reference. Your order will not be
                    shipped until the funds have cleared in our account.
                  </p>
                </div>
              )}
            </div>
            <div className="payment-item">
              <div className="form-check common-check common-radio py-16 mb-0">
                <input
                  className="form-check-input"
                  type="radio"
                  name="payment"
                  id="payment3"
                  checked={selectedPayment === "payment3"}
                  onChange={handlePaymentChange}
                />
                <label
                  className="form-check-label fw-semibold text-neutral-600"
                  htmlFor="payment3"
                >
                  Cash on delivery
                </label>
              </div>
              {selectedPayment === "payment3" && (
                <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                  <p className="text-gray-800">
                    Make your payment directly into our bank account. Please use
                    your Order ID as the payment reference. Your order will not be
                    shipped until the funds have cleared in our account.
                  </p>
                </div>
              )}
            </div>
          </div> */}
          <div className={`mt-32 mb-32 ${selectedPaymentType === 0 ? "" : "d-none"}`}>
            {activeBank.map(
              (bank, index) => (
                <div className="payment-item" key={index}>
                  <div className="form-check common-check common-radio py-16 mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment"
                      id={bank.id}
                      checked={selectedBankId !== null && selectedBankId === bank.id}
                      onChange={handlePaymentChange}
                    />
                    <label
                      className="form-check-label fw-semibold text-neutral-600"
                      htmlFor={bank.id}
                    >
                      <div className="d-flex align-items-center gap-16">
                        <div
                          className="d-flex align-items-center justify-content-center overflow-hidden border border-gray-100"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <img
                            src={bank.logo ?? ""}
                            alt=""
                            className="w-100 h-100 object-fit-contain"
                          />
                        </div>

                        <span>{bank.bankName}</span>
                      </div>
                    </label>
                  </div>
                </div>
              )
            )}
          </div>
          {/* <div className={`mt-32 mb-32`}>
            {paymentMethods.map(
              (payment, index) =>
                payment.type === 0 && (
                  <div className="payment-item" key={index}>
                    <div className="form-check common-check common-radio py-16 mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="payment"
                        id={payment.id}
                        checked={selectedPayment === payment.id}
                        onChange={handlePaymentChange}
                      />
                      <label
                        className="form-check-label fw-semibold text-neutral-600"
                        htmlFor={payment.id}
                      >
                        <div className="d-flex align-items-center gap-16">
                          <div
                            className="d-flex align-items-center justify-content-center overflow-hidden border border-gray-100"
                            style={{ width: "50px", height: "50px" }}
                          >
                            <img
                              src={`assets/images/payment/${payment.img}`}
                              alt=""
                              className="w-100 h-100 object-fit-contain"
                            />
                          </div>

                          <span>{payment.name}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                )
            )}
          </div>
          <div className={`mt-32 mb-32`}>
            {paymentMethods.map(
              (payment, index) =>
                payment.type === 1 && (
                  <div className="payment-item" key={index}>
                    <div className="form-check common-check common-radio py-16 mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="payment"
                        id={payment.id}
                        checked={selectedPayment === payment.id}
                        onChange={handlePaymentChange}
                      />
                      <label
                        className="form-check-label fw-semibold text-neutral-600"
                        htmlFor={payment.id}
                      >
                        <div className="d-flex align-items-center gap-16">
                          <div
                            className="d-flex align-items-center justify-content-center overflow-hidden border border-gray-100"
                            style={{ width: "50px", height: "50px" }}
                          >
                            <img
                              src={`assets/images/payment/${payment.img}`}
                              alt=""
                              className="w-100 h-100 object-fit-contain"
                            />
                          </div>

                          <span>{payment.name}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                )
            )}
          </div>
          <div
            className={`mt-32 mb-32 ${selectedPaymentType === 2 ? "d-block" : "d-none"
              }`}
          >
            {paymentMethods.map(
              (payment, index) =>
                payment.type === 2 && (
                  <div className="payment-item" key={index}>
                    <div className="form-check common-check common-radio py-16 mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="payment"
                        id={payment.id}
                        checked={selectedPayment === payment.id}
                        onChange={handlePaymentChange}
                      />
                      <label
                        className="form-check-label fw-semibold text-neutral-600"
                        htmlFor={payment.id}
                      >
                        <div className="d-flex align-items-center gap-16">
                          <div
                            className="d-flex align-items-center justify-content-center overflow-hidden border border-gray-100"
                            style={{ width: "50px", height: "50px" }}
                          >
                            <img
                              src={`assets/images/payment/${payment.img}`}
                              alt=""
                              className="w-100 h-100 object-fit-contain"
                            />
                          </div>

                          <span>{payment.name}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                )
            )}
          </div> */}
          <div className="pb-20 border-top border-gray-100 d-flex gap-20">
            <p className="text-md mt-22 text-gray-600">
              By placing an order, you agree to our{" "}
              <span className="text-main-one-600 text-decoration-underline">
                terms and conditions
              </span>
              . You also confirm that you have read and understood our <a
                className="mt-22 text-main-one-600 text-decoration-underline"
                href="#"
              >
                return policy
              </a>
            </p>

          </div>
          <div className="mt-22 d-flex align-items-center justify-content-center">
            <button
              className="btn btn-main-one text-white px-80 py-18"
              onClick={onCheckout}
              disabled={checkoutStatus === "loading"}
            >
              Place Order
            </button>
          </div>
        </div>
      </section>
      <ModalGlobal
        show={show}
        onClose={handleClose}
        title="Select Shipment"
      >
        {
          Array.isArray(activeShipment) && activeShipment.length > 0 ? (
            <Accordion defaultActiveKey={selectedShipmentData?.id ?? null}>
              {
                activeShipment.map((shipment, index) => (
                  <Accordion.Item eventKey={shipment.id} key={index}>
                    <Accordion.Header className="bg-main-one-100">{shipment.name}</Accordion.Header>
                    <Accordion.Body>
                      {
                        shipment.details.map((detail, index) => (
                          <div className="border border-gray-100 d-flex flex-between align-items-center rounded-8 px-30 py-20 mb-10 w-100">
                            <div className="form-check common-check common-radio w-100 mb-0">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={detail.expeditionSettingId}
                                id={detail.id}
                                checked={selectedShipmentDetailData?.id === detail.id ?? false}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedShipmentData(shipment);
                                    setSelectedShipmentDetailData(detail);
                                    setOrderShipping(detail?.price);
                                    setShow(false);
                                  }
                                }}
                              />
                              <label
                                className=" ms-16 w-100 text-neutral-600"
                                htmlFor={detail.id}
                              >
                                <div className="d-block d-lg-flex w-100 align-items-center justify-content-between">
                                  <span className="w-100">{detail.name}</span>
                                  <span className="text-sm w-100 text-gray-600 text-end">
                                    ${detail.price}
                                  </span>
                                </div>
                              </label>
                            </div>
                          </div>
                        ))
                      }
                      {/* <ShipmentDetail shipmentDetail={shipment.details} /> */}
                    </Accordion.Body>
                  </Accordion.Item>
                ))
              }
            </Accordion>
          ) : (
            <p className="text-center text-gray-500">No shipment method available</p>
          )
        }
      </ModalGlobal>
    </>
  );
};

export default Checkout;
